import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { UserStore } from '@core/stores/user/user.store'

export const guestGuard: CanActivateFn = async () => {
  const userStore = inject(UserStore)
  const router = inject(Router)

  await userStore.getUser()
  if (!userStore.isAuthenticated()) return true

  router.navigate(['/'])
  return false
}
